import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LogHoursDialogComponent } from '../log-hours-dialog/log-hours-dialog.component';
import { TrainingsTrackerService } from '../trainings_tracker/trainings_tracker_header/trainings_tracker.service';
import { AuthServiceService } from '../../services/auth-service.service';
import { ExcelService } from 'src/app/services/excel-service.service';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-mentor-mentee-dashboard',
  templateUrl: './mentor-mentee-dashboard.component.html',
  styleUrls: ['./mentor-mentee-dashboard.component.css']
})
export class MentorMenteeDashboardComponent {

  selectedTabIndex: number = 0;

  mentorSearchQuery: string = '';

  menteeSearchQuery: string = '';

  mentorViewColumns: string[] = [
    'menteeName',
    'trainingName',
    'menteeHours',
    'mentorHours',
    'completedStatus',
    'status',
    'startDate',
    'endDate',
    'actions'
  ];

  menteeViewColumns: string[] = [
    'mentorName',
    'trainingName',
    'menteeHours',
    'mentorHours',
    'completedStatus',
    'status',
    'startDate',
    'endDate',
    'actions'
  ];

  mentorViewList: any[] = [];

  menteeViewList: any[] = [];

  filteredMentorViewList: any[] = [];

  filteredMenteeViewList: any[] = [];

  mentorViewDataSource: any[] = [];

  menteeViewDataSource: any[] = [];

  mentorViewFrom: number = 0;

  mentorViewTo: number = 10;

  menteeViewFrom: number = 0;

  menteeViewTo: number = 10;

  isMentorViewLoading: boolean = false;

  isMenteeViewLoading: boolean = false;

  @ViewChild(MatPaginator) mentorPaginator: MatPaginator;

  @ViewChild(MatPaginator) menteePaginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private trainingsTrackerService: TrainingsTrackerService,
    private authService: AuthServiceService,
    private excelService: ExcelService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    const employeeId = this.authService.getEmployeeId();
    this.getCMFMenteeSummary(employeeId);
    this.getCMFMentorSummary(employeeId);
  }

  getCMFMenteeSummary(employeeId: any) {
    this.isMentorViewLoading = true;
    this.trainingsTrackerService.getCMFMenteeSummary(employeeId).subscribe((res) => {
      this.mentorViewList = res && res.length > 0 ? res.filter((item: any) => item.menteeName !== null) : [];
      this.filteredMentorViewList = this.mentorViewList;
      this.mentorViewDataSource = this.mentorViewList.slice(this.mentorViewFrom, this.mentorViewTo);
      this.cdr.detectChanges();
      this.isMentorViewLoading = false;
    });
  }

  getCMFMentorSummary(employeeId: any) {
    this.isMenteeViewLoading = true;
    this.trainingsTrackerService.getCMFMentorSummary(employeeId).subscribe((res) => {
      this.menteeViewList = res && res.length > 0 ? res.filter((item: any) => item.mentorName !== null) : [];
      this.filteredMenteeViewList = this.menteeViewList;
      this.menteeViewDataSource = this.menteeViewList.slice(this.menteeViewFrom, this.menteeViewTo);
      this.cdr.detectChanges();
      this.isMenteeViewLoading = false;
    }); 
  }

  onTabChange() {
    this.mentorViewFrom = 0;
    this.mentorViewTo = 10;
    this.menteeViewFrom = 0;
    this.menteeViewTo = 10;
    this.mentorViewDataSource = this.mentorViewList.slice(this.mentorViewFrom, this.mentorViewTo);
    this.menteeViewDataSource = this.menteeViewList.slice(this.menteeViewFrom, this.menteeViewTo);
  }

  searchMentorsView() {
    this.filteredMentorViewList = this.mentorViewList.filter(
      (item: any) => {
        const searchQuery = this.mentorSearchQuery.toLowerCase();
        const trainingNameMatch = item.trainingName && 
          item.trainingName.toLowerCase().includes(searchQuery);
        const menteeNameMatch = item.menteeName && 
          item.menteeName.toLowerCase().includes(searchQuery);
        
        return trainingNameMatch || menteeNameMatch;
      }
    );
    this.mentorViewDataSource = this.filteredMentorViewList.slice(this.mentorViewFrom, this.mentorViewTo);
    this.mentorPaginator.firstPage();
  }

  searchMenteesView() {
      this.filteredMenteeViewList = this.menteeViewList.filter(
        (item: any) => {
          const searchQuery = this.menteeSearchQuery.toLowerCase();
          const trainingNameMatch = item.trainingName && 
            item.trainingName.toLowerCase().includes(searchQuery);
          const mentorNameMatch = item.mentorName && 
            item.mentorName.toLowerCase().includes(searchQuery);
          
          return trainingNameMatch || mentorNameMatch;
        }
      );
    this.menteeViewDataSource = this.filteredMenteeViewList.slice(this.menteeViewFrom, this.menteeViewTo);
    this.menteePaginator.firstPage();
  }

  updateSearchQuery(e, isMentorView) {
    if (e.key === 'Backspace') {
      if (isMentorView && this.mentorSearchQuery === '') {
        this.mentorSearchQuery = '';
        this.filteredMentorViewList = this.mentorViewList;
        this.mentorViewDataSource = this.filteredMentorViewList.slice(this.mentorViewFrom, this.mentorViewTo);
        this.mentorPaginator.firstPage();
      } else if (!isMentorView && this.menteeSearchQuery === '') {
        this.menteeSearchQuery = '';
        this.filteredMenteeViewList = this.menteeViewList;
        this.menteeViewDataSource = this.filteredMenteeViewList.slice(this.menteeViewFrom, this.menteeViewTo);
        this.menteePaginator.firstPage();
      }
    }

  }

  exportTrainingData(isMentorView: boolean) {
    if (isMentorView) {
      const exportData = this.mentorViewList.map((item: any) => ({
        'Mentee Name': item.menteeName,
        'Training Name': item.trainingName,
        'Mentee Hours': `${item.menteeHours} hrs`,
        'Mentor Hours': `${item.mentorHours} hrs`,
        'Completed Percentage': item.completedPercentage ? `${item.completedPercentage}%` : '0%',
        'Status': item.status,
        'Start Date': item.startDate,
        'End Date': item.endDate,
      }));

      if (exportData.length > 0) {
        this.excelService.exportToExcel(exportData, 'Mentor Summary');
      } else {
        this.toastr.error('No data to export');
      }
    } else {
      const exportData = this.menteeViewList.map((item: any) => ({
        'Mentor Name': item.mentorName,
        'Training Name': item.trainingName,
        'Mentee Hours': `${item.hoursSpent} hrs`,
        'Mentor Hours': `${item.mentorHours} hrs`,
        'Completed Percentage': item.completedPercentage ? `${item.completedPercentage}%` : '0%',
        'Status': item.status,
        'Start Date': item.startDate,
        'End Date': item.endDate,
      }));

      if (exportData.length > 0) {
        this.excelService.exportToExcel(exportData, 'Mentee Summary');
      } else {
        this.toastr.error('No data to export');
      }
    }
  }

  openLogHoursDialog(isMentor: boolean, details: any) {
    const dialogRef = this.dialog.open(LogHoursDialogComponent, {
      width: '850px',
      height: '550px',
      disableClose: true,
      data: {
        isMentor: isMentor,
        details: details,
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const employeeId = this.authService.getEmployeeId();
        if (isMentor) {
          this.getCMFMenteeSummary(employeeId);
        } else {
          this.getCMFMentorSummary(employeeId);
        }
      }
    });
  }

  onPageChange(event: any, isMentor: boolean) {
    if (isMentor) {
      this.mentorViewFrom = event.pageIndex * event.pageSize;
      this.mentorViewTo = this.mentorViewFrom + event.pageSize;
      this.mentorViewDataSource = this.filteredMentorViewList.slice(this.mentorViewFrom, this.mentorViewTo);
    } else {
      this.menteeViewFrom = event.pageIndex * event.pageSize;
      this.menteeViewTo = this.menteeViewFrom + event.pageSize;
      this.menteeViewDataSource = this.filteredMenteeViewList.slice(this.menteeViewFrom, this.menteeViewTo);
    }
  }

  clearSearch(e: any, isMentor: boolean) {
    if (isMentor) {
      const isFilterActive = this.filteredMentorViewList.length !== this.mentorViewList.length;
      this.mentorSearchQuery = '';
      this.filteredMentorViewList = this.mentorViewList;
      this.mentorViewDataSource = this.filteredMentorViewList.slice(this.mentorViewFrom, this.mentorViewTo);
      if (isFilterActive) {
        this.mentorPaginator.firstPage();
      }
    } else {
      const isFilterActive = this.filteredMenteeViewList.length !== this.menteeViewList.length;
      this.menteeSearchQuery = '';
      this.filteredMenteeViewList = this.menteeViewList;
      this.menteeViewDataSource = this.filteredMenteeViewList.slice(this.menteeViewFrom, this.menteeViewTo);
      if (isFilterActive) {
        this.menteePaginator.firstPage();
      }
    }
  }

}
